"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfNumberingList = exports.RtfNumberingListType = void 0;
var RtfNumberingListType;
(function (RtfNumberingListType) {
    RtfNumberingListType[RtfNumberingListType["Unknown"] = 0] = "Unknown";
    RtfNumberingListType[RtfNumberingListType["Hybrid"] = 1] = "Hybrid";
    RtfNumberingListType[RtfNumberingListType["Simple"] = 2] = "Simple";
})(RtfNumberingListType = exports.RtfNumberingListType || (exports.RtfNumberingListType = {}));
var RtfNumberingList = (function () {
    function RtfNumberingList() {
        this.levels = [];
        this.numberingListType = RtfNumberingListType.Unknown;
    }
    return RtfNumberingList;
}());
exports.RtfNumberingList = RtfNumberingList;
